/** 单日板块数据 */
export interface DailyRecord {
  /** YYYY-MM-DD */
  date: string;
  first: string;
  second: string;
  third: string;
}

/** 完整存储结构 */
export interface AStockData {
  dailyData: DailyRecord[];
  sectorScores: Record<string, number>;
}

/** 板块得分权重 */
export const SECTOR_WEIGHTS = {
  first: 50,
  second: 30,
  third: 20,
} as const;

/** API 统一响应 */
export type ApiResponse<T> =
  | { ok: true; data: T }
  | { ok: false; error: { code: string; message: string } };

/** 导入结果 */
export interface ImportResult {
  successCount: number;
  errorCount: number;
  errors: string[];
  duplicates: string[];
}
